import React from "react"
import { Route, Switch, withRouter } from "react-router-dom"

import UserApp from "./UserApp"
import AdminApp from "./AdminApp"

//------------------------------------------------------------------------------

function RoutedApp(props) {
    const {
        location: { pathname },
    } = props

    // -------------------------------------

    return (
        <Switch>
            {!pathname.includes?.("admin") && (
                <Route path="/" component={UserApp} />
            )}

            {pathname.includes?.("admin") && (
                <Route path="/admin" component={AdminApp} />
            )}
        </Switch>
        // ----------------------------------------------------------------------------
        // Admin Application
        // ----------------------------------------------------------------------------
    )
}

// ----------------------------------------------------------------------------
// Router wrapper
// ----------------------------------------------------------------------------

const RoutedAppWithRouter = withRouter(RoutedApp)

// ----------------------------------------------------------------------------

export default RoutedAppWithRouter
